import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpGatewayService } from '../services/http-gateway.service';
import { UserContract } from '../store/authentication/types';

@Injectable({ providedIn: 'root' })
export class AuthenticationApi {
  private httpService = inject(HttpGatewayService);

  public getLoggedInUser(): Observable<UserContract> {
    return this.httpService.get<UserContract>('/auth/loggedInUser');
  }
}
